// extracted by mini-css-extract-plugin
export var actions = "_sa-4";
export var item = "_sa-1";
export var price = "_sa-3";
export var quantity = "_sa-2";
export var table = "_sa-0";